import React from "react";
import { Link } from "react-router-dom";
import { SERVICES, PRICING_DISCLAIMER } from "@/lib/api";

const RANGES = {
  "household-junk": "$89 – $129+",
  "yard-debris": "$129 – $179+",
  "construction-debris": "$199 – $299+",
  "bulk-pickup": "$79 – $109+",
  "appliance-removal": "$89 – $109+",
  "eviction-cleanout": "$499 – $849+",
  "storm-cleanup": "$175 – $249+",
  "dumpster-rental": "$349 – $499+",
};

const ACCEPTED = ["Furniture", "Mattresses", "Appliances", "Boxes", "Household junk", "Yard debris", "Garage junk", "Rental cleanouts", "Construction debris", "Bulk items"];
const NOT_ACCEPTED = ["Paint", "Chemicals", "Gasoline / oil", "Asbestos", "Medical waste", "Biohazards", "Large amounts of tires", "Hazardous waste", "Large concrete / dirt / brick loads (custom quote only)"];

const Pricing = () => (
  <div data-testid="pricing-page">
    <section className="border-b border-border bg-muted">
      <div className="container-wide py-16 lg:py-20">
        <p className="kicker">Pricing</p>
        <h1 className="mt-3 font-display text-4xl font-black sm:text-5xl lg:text-6xl">Starting prices, upfront.</h1>
        <p className="mt-4 max-w-2xl text-lg text-muted-foreground">
          Every job is quoted based on photos and details, but here are the starting ranges for each service.
        </p>
      </div>
    </section>

    <section className="section">
      <div className="container-wide">
        <div className="overflow-hidden rounded-sm border border-border">
          <table className="w-full text-left text-sm" data-testid="pricing-table">
            <thead className="bg-card">
              <tr>
                <th className="px-4 py-3 font-display text-base font-bold">Service</th>
                <th className="px-4 py-3 text-right font-display text-base font-bold">Starting price</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border bg-card">
              {SERVICES.map((s) => (
                <tr key={s.slug} data-testid={`pricing-row-${s.slug}`}>
                  <td className="px-4 py-3">
                    <span className="font-semibold">{s.title}</span>
                    <p className="text-xs text-muted-foreground">{s.short}</p>
                  </td>
                  <td className="whitespace-nowrap px-4 py-3 text-right font-semibold text-primary">From {RANGES[s.slug]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="mt-6 max-w-3xl text-sm text-muted-foreground">{PRICING_DISCLAIMER}</p>

        <div className="mt-12 grid gap-8 md:grid-cols-2">
          <div className="rounded-sm border border-border bg-card p-6">
            <h3 className="font-display text-xl font-bold">Items we accept</h3>
            <ul className="mt-4 grid grid-cols-2 gap-y-2 text-sm">
              {ACCEPTED.map((i) => (<li key={i} className="text-foreground/85">✓ {i}</li>))}
            </ul>
          </div>
          <div className="rounded-sm border border-border bg-card p-6">
            <h3 className="font-display text-xl font-bold">We can&apos;t take</h3>
            <ul className="mt-4 grid grid-cols-1 gap-y-2 text-sm">
              {NOT_ACCEPTED.map((i) => (<li key={i} className="text-foreground/85">✕ {i}</li>))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start gap-4 rounded-sm bg-[hsl(145,27%,24%)] p-8 text-white sm:flex-row sm:items-center sm:justify-between">
          <p className="font-display text-xl font-bold">Ready for a firm price? Send photos.</p>
          <Link to="/contact" className="btn-cta" data-testid="pricing-cta">Get a Free Quote</Link>
        </div>
      </div>
    </section>
  </div>
);
export default Pricing;
